<div class="settings-container" [ngClass]="{open:displaySettings}">

    <div class="row toggle-row" *ngIf="this.class=='ltr'" [ngClass]="{open:displaySettings }">
        <button class="toggle-display-button" (click)="toggleSettings()">
            <i class="pi pi-chevron-right"></i>
            <span>{{'ROULETTE.EDIT'|translate}}</span>
        </button>
        <label>{{roulette &&
            roulette.GeneralDetails? roulette.GeneralDetails.Name: 'ROULETTE.MYֹ_ROULETTE'|translate}}</label>
    </div>
    <!-- hebrew -->
    <div class="row toggle-row" *ngIf="this.class=='rtl'" [ngClass]="{open:displaySettings,hebrew: class=='rtl' }">
        <label>{{roulette &&
            roulette.GeneralDetails? roulette.GeneralDetails.Name: 'ROULETTE.MYֹ_ROULETTE'|translate}}</label>
        <button class="toggle-display-button" (click)="toggleSettings()">
            <i class="pi pi-chevron-right"></i>
            <span>{{'ROULETTE.EDIT'|translate}}</span>
        </button>
       
    </div>
   

    <p-tabView *ngIf="displaySettings">
        <p-tabPanel header="{{'ROULETTE.STYLE'|translate}}">
            <app-roulette-design-settings [roulette]="roulette" [form]="form"></app-roulette-design-settings>
        </p-tabPanel>
        <p-tabPanel header="{{'ROULETTE.AWARDS'|translate}}">
            <app-roulette-coupons-settings [roulette]="roulette" [form]="form"></app-roulette-coupons-settings>
        </p-tabPanel>
        <p-tabPanel header="{{'ROULETTE.LOGO'|translate}}">
            <app-roulette-logo-settings [roulette]="roulette"></app-roulette-logo-settings>
        </p-tabPanel>
        <p-tabPanel header="{{'ROULETTE.DEFINITIONS'|translate}}">
            <app-roulette-general-details [roulette]="roulette"></app-roulette-general-details>
        </p-tabPanel>
    </p-tabView>

</div>